import Client from "..";
import { GameEvents } from "../utils/Types";
import { NineSlicePresets } from "./NineSlicePresets";
import { NumberCounter } from "./NumberCounter";

export class ScoreContainer extends Phaser.GameObjects.Container {
  private scoreBackground: Phaser.GameObjects.NineSlice;
  private scoreCounter: NumberCounter;

  private winBackground: Phaser.GameObjects.NineSlice;
  private winCounter: NumberCounter;

  private winMultiplierBackground: Phaser.GameObjects.NineSlice;
  private winMultiplierCounter: NumberCounter;

  constructor(scene: Phaser.Scene) {
    super(scene);

    this.winBackground = NineSlicePresets.Default(scene).setTint(0xac4c3f);
    this.add(this.winBackground);

    this.winCounter = new NumberCounter(
      scene,
      Client.state.win,
      GameEvents.WIN_UPDATED,
    ).setOrigin(0.5, 0.45);
    this.add(this.winCounter);

    this.winMultiplierBackground = NineSlicePresets.Default(scene).setTint(
      Client.state.winMultiplierColor,
    );
    this.add(this.winMultiplierBackground);

    this.winMultiplierCounter = new NumberCounter(
      scene,
      Client.state.winMultiplier,
    )
      .setOrigin(0.5, 0.45)
      .SetPrefix("x")
      .SetImmediate(true);
    this.add(this.winMultiplierCounter);

    this.scoreBackground = NineSlicePresets.Default(scene).setTint(0xac4c3f);
    this.add(this.scoreBackground);

    this.scoreCounter = new NumberCounter(
      scene,
      Client.state.score,
      GameEvents.SCORE_UPDATED,
    ).setOrigin(0.5, 0.4);
    this.add(this.scoreCounter);

    Client.game.events.on(
      GameEvents.WIN_MULTIPLIER_UPDATED,
      this.onWinMultiplierUpdated,
      this,
    );
    Client.game.events.on(
      GameEvents.WIN_MULTIPLIER_APPLIED,
      this.onWinMultiplierApplied,
      this,
    );
  }

  Resize(width: number = this.width, height: number = this.height): this {
    this.setSize(width, height);

    this.scoreBackground
      .setSize(width, height * 0.6)
      .setDisplaySize(width, height * 0.6);
    this.scoreBackground.setPosition(
      this.scoreBackground.displayWidth * 0.5,
      this.scoreBackground.displayHeight * 0.5,
    );

    const marginX = width * 0.1;
    const marginY = -height * 0.1;

    const elementPadding = width * 0.05;
    const availableWinContainer = width - marginX - elementPadding;

    this.winBackground
      .setSize(
        availableWinContainer * 0.8,
        height - this.scoreBackground.displayHeight - marginY,
      )
      .setDisplaySize(
        availableWinContainer * 0.8,
        height - this.scoreBackground.displayHeight - marginY,
      );

    this.winBackground.setPosition(
      this.winBackground.displayWidth * 0.5 +
        width -
        this.winBackground.displayWidth -
        marginX * 0.5,
      this.winBackground.displayHeight * 0.5 +
        this.scoreBackground.displayHeight +
        marginY,
    );

    this.winMultiplierBackground
      .setSize(
        availableWinContainer - this.winBackground.displayWidth,
        height - this.scoreBackground.displayHeight - marginY,
      )
      .setDisplaySize(
        availableWinContainer - this.winBackground.width,
        height - this.scoreBackground.displayHeight - marginY,
      );
    this.winMultiplierBackground.setPosition(
      this.winMultiplierBackground.displayWidth * 0.5 + marginX * 0.5,
      this.winMultiplierBackground.displayHeight * 0.5 +
        this.scoreBackground.displayHeight +
        marginY,
    );

    this.scoreCounter.setFontSize(this.scoreBackground.displayHeight * 0.6);
    this.scoreCounter.setPosition(
      this.scoreBackground.x,
      this.scoreBackground.y,
    );

    this.winCounter.setFontSize(this.winBackground.displayHeight * 0.5);
    this.winCounter.setPosition(
      this.winBackground.x,
      this.winBackground.y - marginY * 0.5,
    );

    this.winMultiplierCounter.setFontSize(
      this.winMultiplierBackground.displayHeight * 0.5,
    );
    this.winMultiplierCounter.setPosition(
      this.winMultiplierBackground.x,
      this.winMultiplierBackground.y - marginY * 0.5,
    );

    this.winMultiplierCounter.setData("originalY", this.winMultiplierCounter.y);
    this.winMultiplierBackground.setData(
      "originalY",
      this.winMultiplierBackground.y,
    );

    return this;
  }

  private onWinMultiplierUpdated(multiplier: number, color?: number): void {
    const tweenToY =
      this.winMultiplierBackground.getData("originalY") +
      this.winMultiplierCounter.displayHeight * 0.5 -
      this.scoreBackground.displayHeight;
    const createTween = (
      element: Phaser.GameObjects.NineSlice | NumberCounter,
    ) => {
      element.getData("multiplierTween")?.stop();

      const multiplierTween = this.scene.tweens.chain({
        targets: element,
        tweens: [
          {
            duration: 200,
            y: { from: element.y, to: tweenToY },
            onComplete: () =>
              element === this.winMultiplierCounter &&
              this.winMultiplierCounter.OnNumberUpdateEvent(multiplier),
          },
          {
            duration: 200,
            y: element.getData("originalY"),
          },
        ],
      });

      element.setData("multiplierTween", multiplierTween);
    };

    createTween(this.winMultiplierCounter);
    createTween(this.winMultiplierBackground);

    // Update color if provided
    if (color !== undefined) {
      this.winMultiplierBackground.setTint(color);
    }
  }

  private onWinMultiplierApplied(): void {
    this.winMultiplierCounter.getData("multiplierApplierTween")?.stop();

    const tween = this.scene.tweens.chain({
      targets: this.winMultiplierCounter,
      tweens: [
        {
          duration: 200,
          scale: 1.4,
        },
        {
          duration: 200,
          scale: 1,
        },
      ],
    });

    this.winMultiplierCounter.setData("multiplierApplierTween", tween);
  }
}
